angular.module('ikeweb').run(['$location', '$rootScope', 'loginService',
    function($location, $rootScope, $loginService) {

        var unsecurePaths = [
            '/login',
            '/forgotPassword',
            '/signup',
            '/measureView/.*',
            '/error',
            '/choose_password',
            '/invalid_link',
            '/password_reset_success'
        ];

        function isUnsecurePath(path) {
            return unsecurePaths.reduce(function(result, unsecurePath) {
                return result || new RegExp(unsecurePath).test(path);
            }, false);
        }

        function checkLogin() {
            if ($loginService.getLoggedInUser() === null && !isUnsecurePath($location.path())) {
                $location.path('login');
            }
        }

        $rootScope.$on('$locationChangeStart', function() {
            checkLogin();
        });

        checkLogin();
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/check.login.run.js
// module id = 435
// module chunks = 0